import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';

import { authSetIsTransitioningAction } from '@/Module/Auth/Store/Slice/AuthSlice';
import { LINKS } from '@/Module/Core/Constant';
import type { IEntity } from '@/Module/Core/Model/DataModel';
import { CookieService } from '@/Module/Core/Service';
import { useAppDispatch } from '@/Module/Store/Hook';

export const useCompleteSteps = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const shadToken = CookieService.getShadToken();
  const rubikaToken = CookieService.getRubikaToken();

  const regex = /^\/?subscription\/\d+\/?$/;
  const isSubscription = regex.test(decodeURIComponent((router.query?.redirectUrl as string) ?? ''));

  const redirectUrl = useMemo(() => {
    if (shadToken) {
      return LINKS.LEARNING;
    }

    if (rubikaToken) {
      if (isSubscription) {
        return router.query?.redirectUrl as string;
      }
      return LINKS.LEARNING;
    }

    return router.query?.redirectUrl === '/' ? LINKS.LEARNING : (router.query?.redirectUrl as string) ?? LINKS.LEARNING;
  }, [rubikaToken, shadToken, router, isSubscription]);

  return useCallback(
    async ({ isLogin, userId }: { isLogin?: boolean; userId?: IEntity['id'] }) => {
      if (typeof window !== 'undefined' && window.dataLayer && isLogin) {
        window.dataLayer.push({
          event: 'login',
          method: 'otp',
          userId,
        });
      }
      dispatch(authSetIsTransitioningAction(true));
      try {
        return await router.push(redirectUrl);
      } finally {
        dispatch(authSetIsTransitioningAction(false));
      }
    },
    [redirectUrl],
  );
};
